import { ComunidadTab } from "../psychologist/tabs";

export const ComunidadPage = () => {
  return <ComunidadTab />;
};
